import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Pricing } from "./pages/Pricing";
import { Contact } from "./pages/Contact";
import { Quote } from "./pages/Quote";
import { FAQ } from "./pages/FAQ";
import { Portfolio } from "./pages/Portfolio";
import { Blog } from "./pages/Blog";
import {
  LegalNotice,
  PrivacyPolicy,
  CookiesPolicy,
  Licenses,
} from "./pages/Legal";
import ScrollToTop from "./components/scrollToTop";
import ServiceDetail from "./pages/ServiceDetail";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />

        <Layout>
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/tarifs" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/devis" element={<Quote />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/realisations" element={<Portfolio />} />
            <Route path="/blog" element={<Blog />} />

            {/* Legal Pages */}
            <Route path="/mentions-legales" element={<LegalNotice />} />
            <Route path="/confidentialite" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiesPolicy />} />
            <Route path="/licences" element={<Licenses />} />

            {/* Fallback */}
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;